import { TableHeader } from './TableHeader';
import { TableRow } from './TableRow';
import './Table.scss';

export interface IColumnType<T> {
    key: string;
    title: string;
    width?: string;
    render?: (column: IColumnType<T>, item: T) => void;
}

interface Props<T> {
    data: T[];
    columns: IColumnType<T>[];
    className?: string;
}

export function Table<T>({ data, columns, className }: Props<T>): JSX.Element {
    return (
        <table className={`TableComponent ${className}`}>
            <thead>
                <TableHeader columns={columns} />
            </thead>
            <tbody>
                <TableRow data={data} columns={columns} />
            </tbody>
        </table>
    );
}
